import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
<svg width="1345" height="103" viewBox="0 0 1405 103" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clipArrTop0)">
<path d="M1395.44 77.5189V0.559296H13.5582V83" stroke="#1A98FF" strokeWidth="3" strokeMiterlimit="10" strokeDasharray="19 19"/>
</g>
<g clipPath="url(#clipArrTop1)">
<path d="M1395.5 99C1400.75 99 1405 94.7467 1405 89.5C1405 84.2533 1400.75 80 1395.5 80C1390.25 80 1386 84.2533 1386 89.5C1386 94.7467 1390.25 99 1395.5 99Z" fill="#1A98FF"/>
<g clipPath="url(#clipArrTop2)">
<path d="M3251.9 185.9V-20.5H-461.5V200.6" stroke="#1A98FF" strokeWidth="3" strokeMiterlimit="10" strokeDasharray="34 34"/>
</g>
</g>
<path d="M28 83L14.0253 103L0 83H28Z" fill="#1A98FF"/>
<defs>
<clipPath id="clipArrTop0">
<rect width="1383" height="83" fill="white" transform="translate(13)"/>
</clipPath>
<clipPath id="clipArrTop1">
<rect width="19" height="19" fill="white" transform="translate(1386 80)"/>
</clipPath>
<clipPath id="clipArrTop2">
<rect width="3716.4" height="222.6" fill="white" transform="translate(-463 -22)"/>
</clipPath>
</defs>
</svg>
)
